import React from 'react';
import cx from 'classnames';

import styles from './Tabs.module.scss';

const Tabs = ({ children, className, noBorder }) => {
    return (
        <ul className={cx(className, styles.tabs, {[styles.tabsNoBorder]: noBorder })}>
            {children}
        </ul>
    )
}

export default Tabs;
